import { FieldValues } from 'react-hook-form';
import { bloodPressureValues } from '../utils/common';
import { env } from 'env';
import { http } from 'app/http';
import { ModelResultType } from '../IGPRScore.interface';
import { AxiosResponse } from 'axios';
import {
  AutocompleteResult,
  AutocompleteResultType
} from './autocompleteResultRepository.interface';

const BASE_URL = env.REACT_APP_BFF_API;

export async function fetchMedicationAndMedicalProblemsResults(
  endpoint: string,
  searchedValue: string
): Promise<{ results: AutocompleteResult[] }> {
  endpoint = endpoint === 'problems' ? 'medical-problems' : endpoint;
  const result = await http.get(
    `${BASE_URL}/life/igpr/${endpoint}?filter=${searchedValue}&pageSize=500`
  );
  if (result.status === 200 || result.status === 201) {
    return (await result.data) as { results: AutocompleteResult[] };
  }
  throw new Error(`STATUS: ${result.status}`);
}

export async function sendAiModelResult(
  data: FieldValues
): Promise<ModelResultType> {
  const [systolic, diastolic] = bloodPressureValues(data.blood_pressure);
  const dataCloned = structuredClone(data);

  dataCloned.medications.reduce(
    (
      all: any,
      medication: { value: AutocompleteResultType },
      index: number
    ) => {
      delete medication.value.value;
      medication.value.rate = medication.value.decline_rate;
      delete medication.value.decline_rate;
      medication.value.type = 'medications';
      Object.defineProperty(all, index, medication);
      return all;
    },
    {}
  );
  dataCloned.problems.reduce(
    (all: any, problem: { value: AutocompleteResultType }, index: number) => {
      delete problem.value.description;
      delete problem.value.value;
      problem.value.rate = problem.value.decline_rate;
      delete problem.value.decline_rate;
      problem.value.type = 'problems';
      Object.defineProperty(all, index, problem);
      return all;
    },
    {}
  );

  const medications = dataCloned.medications.map(
    (medication: { value: {} }) => medication.value
  );
  const problems = dataCloned.problems.map(
    (problem: { value: {} }) => problem.value
  );

  const newData = {
    important_conditions: {
      bmi: +dataCloned.bmi,
      cholesterol: +dataCloned.cholesterol,
      blood_pressure: {
        systolic,
        diastolic
      },
      blood_sugar: +dataCloned.blood_sugar
    },
    problems,
    medications
  };
  const result: AxiosResponse = await http.post(
    `${BASE_URL}/life/igpr/score`,
    newData
  );

  if (result.status === 200 || result.status === 201) {
    return (await result.data?.results) as ModelResultType;
  }
  throw new Error(`STATUS: ${result.status}`);
}
